import { createContext, useContext, Dispatch, SetStateAction } from 'react';

export enum EnumNavigationBar {
    NotDefined = 0,
    Main = 1,
    Settings = 2,
    Profile = 3,
}

export interface NavigationContextProps {
    navigationBar: EnumNavigationBar;
    setNavigationBar: Dispatch<SetStateAction<EnumNavigationBar>>;
}

const emptyNavigationContextProps: NavigationContextProps = {
    navigationBar: EnumNavigationBar.NotDefined,
    setNavigationBar: () => {},
};

export const useNavigation = (): NavigationContextProps => {
    return useContext(NavigationContext);
};

export const NavigationContext = createContext<NavigationContextProps>(emptyNavigationContextProps);
